/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  GetRpcLatestLocationForVehicleParams,
  PostgrestError,
  RpcLatestLocationForVehicleArgs,
  VehicleLocations
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getRpcLatestLocationForVehicleResponse200 = {
  data: VehicleLocations
  status: 200
}

export type getRpcLatestLocationForVehicleResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getRpcLatestLocationForVehicleResponseSuccess = (getRpcLatestLocationForVehicleResponse200) & {
  headers: Headers;
};
export type getRpcLatestLocationForVehicleResponseError = (getRpcLatestLocationForVehicleResponseDefault) & {
  headers: Headers;
};

export type getRpcLatestLocationForVehicleResponse = (getRpcLatestLocationForVehicleResponseSuccess | getRpcLatestLocationForVehicleResponseError)

export const getGetRpcLatestLocationForVehicleUrl = (params: GetRpcLatestLocationForVehicleParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/rpc/latest_location_for_vehicle?${stringifiedParams}` : `${backendBaseUrl}/rpc/latest_location_for_vehicle`
}

/**
 * @summary Call `latest_location_for_vehicle()`.
 */
export const getRpcLatestLocationForVehicle = async (params: GetRpcLatestLocationForVehicleParams, options?: RequestInit): Promise<getRpcLatestLocationForVehicleResponse> => {

  const res = await fetch(getGetRpcLatestLocationForVehicleUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getRpcLatestLocationForVehicleResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getRpcLatestLocationForVehicleResponse
}


export type postRpcLatestLocationForVehicleResponse200 = {
  data: VehicleLocations
  status: 200
}

export type postRpcLatestLocationForVehicleResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type postRpcLatestLocationForVehicleResponseSuccess = (postRpcLatestLocationForVehicleResponse200) & {
  headers: Headers;
};
export type postRpcLatestLocationForVehicleResponseError = (postRpcLatestLocationForVehicleResponseDefault) & {
  headers: Headers;
};

export type postRpcLatestLocationForVehicleResponse = (postRpcLatestLocationForVehicleResponseSuccess | postRpcLatestLocationForVehicleResponseError)

export const getPostRpcLatestLocationForVehicleUrl = () => {




  return `${backendBaseUrl}/rpc/latest_location_for_vehicle`
}

/**
 * @summary Call `latest_location_for_vehicle()`.
 */
export const postRpcLatestLocationForVehicle = async (rpcLatestLocationForVehicleArgs: RpcLatestLocationForVehicleArgs, options?: RequestInit): Promise<postRpcLatestLocationForVehicleResponse> => {

  const res = await fetch(getPostRpcLatestLocationForVehicleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rpcLatestLocationForVehicleArgs)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postRpcLatestLocationForVehicleResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postRpcLatestLocationForVehicleResponse
}


